
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': '固定',
	'find_label': '尋找',
	'findCancelLabel': '取消',
	'dataPaneLabel': '資料',
	'sourcePaneLabel': '選取的來源',
	'sourcePaneContentLabel': '選取來源',
	'emptySourcePaneTitle': '選取來源',
	'emptySourcePaneCaption': '按一下選取要新增的來源以用來建置儀表板。',
	'addDataSource': '選取來源',
	'addDataDashboardCoachMarkContents': '將資料從資料畫面拖放至儀表板。',
	'addDataStoryCoachMarkContents': '將資料從資料畫面拖放到您的案例。',
	'addDataCoachMarkTitle': '新增資料',
	'selectSourcesText': '選取並新增資料來源以建置您的 %{app}。',
	'selectSourcesLabel': '選取來源',
	'errorSourcesTitle': '無法載入資料樹狀結構',
	'errorLoadingDataSources': '載入資料集清單時發生錯誤',
	'errorLoadingDataTree': '載入樹狀結構時發生錯誤',
	'dataSetPaneLastUpdated': '前次更新日期：%{date}',
	'dataSourcePaneDateUnknown': '不明',
	'moreTitle': '其他',
	'backLabel': '回上頁',
	'addDataSourceDialogTitle': '選取來源',
	'addDataSourceDialogButtonLabel': '新增',
	'dlg_use': '使用',
	'dlg_RelinkDataSourceTitle': '將資料集 "%{dataSourceName}" 取代為 ...',
	'propertiesDialogTitle': '內容',
	'loadingMetadata': '載入 meta 資料',
	'missingDataSetData': '此資料集的資料無法使用。請重新整理此資料集，或聯絡管理者以取得來源的存取權。',
	'errorLoadingSource': '"%{sourceName}" 的 meta 資料未載入。如需詳細資料，請聯絡您的管理者。',
	'errorMessageTitle': '錯誤',
	'calculation_navigation_in_use': '刪除計算、過濾器或導覽路徑會使參照已刪除項目的所有視覺化無效。您確定要刪除嗎？',
	'delete_confirm': '確認刪除',
	'previewUnavailable': '資料匣及廣域過濾器無法用於此套件類型。',
	'contextualGridTabName': '視覺化資料',
	'DATA_TRAY_no_data_text': '您目前沒有任何資料',
	'contextualGridMenuLabel': '視覺化資料功能表',
	'contextualGridExport': '匯出',
	'nullValueText': '空值',
	'forecastDetailsTabName': '預測統計詳細資料',
	'forecastDetailsModelLabel': '模型',
	'forecastDetailsQualityMetricLabel': '精確度測量',
	'forecastDetailsSmoothingCoefLabel': '參數',
	'forecastDetailsDiagnostics': '診斷',
	'forecastDetailsForecastLabel': '預測',
	'forecastDetailsStatusLabel': '狀態',
	'forecastDetailsAccuracyPercentLabel': '精準度 %',
	'forecastDetailsTrendLabel': '趨勢',
	'forecastDetailsSeasonLabel': '季節性',
	'forecastDetailsSeasonalPeriodLabel': '季節性週期',
	'forecastDetailsAlphaLabel': 'α',
	'forecastDetailsBetaLabel': 'β',
	'forecastDetailsGammaLabel': 'γ',
	'forecastDetailsPhiLabel': 'φ',
	'forecastDetailsMissingCount': '遺漏計數',
	'forecastDetailsSeriesLengthLabel': '系列長度',
	'forecastDetailsIgnoredPeriods': '忽略的期間',
	'forecastDetailsTrendStrength': '趨勢強度',
	'forecastDetailsSeasonalityStrength': '季節性強度',
	'forecastDetailsTimeDeltaUnit': '日期/時間間隔',
	'forecastDetailsNotes': '附註'
});
